import { z } from "zod";
import { NpdCalculationState } from "../npd-calculation-state";
import { npdCalculationResultsDtoSchema } from "./npd-calculation-results.schema";
export const npdRunningCalculationStatusDtoSchema = z.object({
    state: z.literal(NpdCalculationState.Running),
    partialResults: npdCalculationResultsDtoSchema,
});
